export const mapTypes = {
    Google: 'google',
    Mapbox: 'mapbox'
};